import { useRef, useState } from "react";
import Header from "./Header";
import { checkValidData } from "../utils/utils/validate";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { auth } from "../utils/utils/firebase";
import { useDispatch } from "react-redux";
import { addUser } from "../utils/utils/userSlice";
import { BG_IMG, USER_AVATAR } from "../utils/utils/constants";

const Login = () => {
  const [isSignInForm, setIsSignInForm] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const email = useRef(null);
  const password = useRef(null);
  const name = useRef(null);

  const toggleSignInForm = () => {
    setIsSignInForm(!isSignInForm);
    setErrorMessage("");
  };

  const handleButtonClick = () => {
    const message = checkValidData(
      email.current.value,
      password.current.value,
      isSignInForm ? undefined : name.current.value,
    );
    setErrorMessage(message);

    if (message) return; //if message is present return from here

    setLoading(true);

    // sign in / sign up logic

    if (!isSignInForm) {
      // sign up logic
      createUserWithEmailAndPassword(
        auth,
        email.current.value,
        password.current.value,
      )
        .then((userCredential) => {
          // Signed up
          const user = userCredential.user;
          // ...
          updateProfile(user, {
            displayName: name.current.value,
            photoURL: USER_AVATAR,
          })
            .then(() => {
              // Profile updated!
              const { uid, email, displayName, photoURL } = auth.currentUser;
              dispatch(
                addUser({
                  uid: uid,
                  email: email,
                  displayName: displayName,
                  photoURL: photoURL,
                }),
              );
              setLoading(false);
            })
            .catch((error) => {
              // An error occurred
              // ...
              setErrorMessage(error.message);
            });
          setLoading(false);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          // ..
          setErrorMessage(
            "Invalid Email/Password...   " + errorCode + " " + errorMessage,
          );
          setLoading(false);
        });
    } else {
      // sign in logic
      signInWithEmailAndPassword(
        auth,
        email.current.value,
        password.current.value,
      )
        .then((userCredential) => {
          // Signed in
          // eslint-disable-next-line no-unused-vars
          const user = userCredential.user;
          // ...
          setLoading(false);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          setErrorMessage(
            "Invalid Email/Password...   " + errorCode + " " + errorMessage,
          );
          setLoading(false);
        });
    }
  };

  return (
    <div className="relative w-screen h-screen overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src={BG_IMG}
          alt="bg"
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      <Header />

      <div className="flex items-center justify-center h-full px-4">
        <form
          onSubmit={(e) => e.preventDefault()}
          className="w-full max-w-sm bg-black/70 backdrop-blur-sm p-6 md:p-10 rounded-lg text-neutral-50 shadow-xl"
        >
          <h1 className="font-bold text-3xl mb-6">
            {isSignInForm ? "Sign In" : "Sign Up"}
          </h1>
          {!isSignInForm && (
            <input
              ref={name}
              type="text"
              placeholder="Name"
              className="p-3 mb-4 w-full bg-neutral-900 rounded-md outline-none focus:ring-1 focus:ring-red-600"
            />
          )}
          <input
            ref={email}
            type="text"
            placeholder="Email Address"
            className="p-3 mb-4 w-full bg-neutral-900 rounded-md outline-none focus:ring-1 focus:ring-red-600"
          />
          <input
            ref={password}
            type="password"
            placeholder="Password"
            className="p-3 mb-2 w-full bg-neutral-900 rounded-md outline-none focus:ring-1 focus:ring-red-600"
          />

          {errorMessage && (
            <p className="text-red-500 text-sm mb-3">{errorMessage}</p>
          )}

          <button
            className="w-full py-2 mt-2 bg-red-700 hover:bg-red-600 rounded-md font-semibold flex items-center justify-center transition disabled:opacity-70 disabled:cursor-progress"
            onClick={handleButtonClick}
            disabled={loading}
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin" />
            ) : isSignInForm ? (
              "Sign In"
            ) : (
              "Sign Up"
            )}
          </button>
          <div>
            <p className="text-gray-300 text-sm mt-6">
              {isSignInForm ? "New to CINEMIX? " : "Already have an account? "}
              <span
                className="font-bold cursor-pointer hover:underline text-neutral-50"
                onClick={toggleSignInForm}
              >
                {isSignInForm ? "Sign up now." : "Sign in now."}
              </span>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
